import React from "react";
import { Send } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import MessageList from "../../../components/MessageList";
import RenderedMessage from "../../../components/RenderedMessage";
import StatusPill from "../../components/StatusPill";
import { CHANNEL_LABEL, DELIVERY_STATUS, SKIP_REASON_LABEL } from "../../features/monitor.constants";

// Read-only view of one message: who it went to, how it went, and the message itself (an email as it was sent).
export default function DeliveryViewDrawer({ record, onClose }) {
  const hasContent = record.rendered_content && Object.keys(record.rendered_content).length > 0;
  const sections = [
    ...(record.error_message ? [{ title: record.status === "FAILED" ? "Error" : "Note", fields: [{ value: <MessageList tone={record.status === "FAILED" ? "problem" : "warning"} items={[record.error_message]} /> }] }] : []),
    {
      title: "Message",
      fields: [
        { label: "Status", value: <StatusPill status={record.status} map={DELIVERY_STATUS} /> },
        ...(record.skip_reason ? [{ label: "Skipped because", value: SKIP_REASON_LABEL[record.skip_reason] ?? record.skip_reason }] : []),
        { label: "Channel", value: CHANNEL_LABEL[record.channel_key] ?? record.channel_key },
        { label: "Recipient", value: record.recipient_name || "—" },
        { label: "Address", value: record.recipient_address || "—" },
        { label: "Recipient type", value: <span className="font-mono">{record.recipient_type_key}</span> },
        { label: "Rule", value: record.rule ? `${record.rule.name} (${record.rule.code})` : `#${record.rule_fid}` },
        { label: "Case", value: `#${record.instance_fid} · step ${record.step_no}, send ${record.send_no}${record.is_escalation ? " (escalation)" : ""}` },
        { label: "Template", value: record.template_fid ? `#${record.template_fid} v${record.template_version_no ?? "?"}` : "—" },
        { label: "Attempts", value: record.attempt_count },
        { label: "Queued", value: record.queued_at ? <LocalDateTime utcTime={record.queued_at} /> : "—" },
        { label: "Sent", value: record.sent_at ? <LocalDateTime utcTime={record.sent_at} /> : "—" },
        ...(record.digest_key ? [{ label: "Digest", value: "One message listing several cases" }] : []),
      ],
    },
    ...(hasContent ? [{ title: "Content", fields: [{ value: <RenderedMessage channelKey={record.channel_key} rendered={record.rendered_content} emailHtml={record.email_html} /> }] }] : []),
  ];

  return <GlobalDetailDrawer open onClose={onClose} title={record.subject || "Reminder message"} subtitle={`Message #${record.id}`} icon={<Send size={20} />} sections={sections} />;
}
